import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { getConsent, setConsent, trackEvent } from "@/lib/analytics";

export default function CookieConsent() {
  const [open, setOpen] = useState(false);
  const [details, setDetails] = useState(false);

  useEffect(() => {
    if (!getConsent()) setOpen(true);
  }, []);

  const choose = (value) => {
    setConsent(value);
    if (value === "accepted") trackEvent("page_view");
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="cookie-consent"
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ type: "spring", damping: 26, stiffness: 260 }}
          className="fixed bottom-3 inset-x-3 sm:inset-x-auto sm:right-4 sm:bottom-4 sm:max-w-sm z-[60] rounded-2xl border border-white/10 bg-zinc-950/90 backdrop-blur-xl p-5 shadow-2xl"
        >
          <div className="flex items-center gap-2 mb-2">
            <Cookie size={16} className="text-pink-400" />
            <p className="text-sm font-semibold text-white">Cookies</p>
          </div>
          <p className="text-xs text-zinc-400 leading-relaxed">
            On utilise des cookies pour mesurer l'audience et améliorer DocLove. Tu choisis.{" "}
            <Link to="/confidentialite" className="text-pink-400 hover:underline">En savoir plus</Link>.
          </p>

          {details && (
            <div className="mt-3 rounded-xl bg-white/5 p-3 text-xs text-zinc-400">
              <p className="font-semibold text-zinc-200 mb-1">Cookies analytiques</p>
              Meta, TikTok & Google Analytics — uniquement si tu acceptes. Aucun cookie publicitaire sans ton accord.
            </div>
          )}

          <div className="mt-4 flex flex-wrap gap-2">
            <button
              data-testid="cookie-accept"
              onClick={() => choose("accepted")}
              className="flex-1 rounded-full bg-pink-500 text-white text-sm font-bold py-2.5 hover:bg-pink-600 transition-colors"
            >
              Accepter
            </button>
            <button
              data-testid="cookie-refuse"
              onClick={() => choose("refused")}
              className="flex-1 rounded-full bg-white/5 border border-white/10 text-white text-sm font-semibold py-2.5 hover:bg-white/10 transition-colors"
            >
              Refuser
            </button>
          </div>
          <button
            data-testid="cookie-customize"
            onClick={() => setDetails((d) => !d)}
            className="mt-2 w-full text-center text-xs text-zinc-500 hover:text-zinc-300"
          >
            {details ? "Masquer" : "Personnaliser"}
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
